export { icons } from './footer.data-en';

export const navItems = [
  {
    title: 'TiDB 社区',
    items: [
      {
        title: 'TiKV',
        link: 'https://tikv.org',
      },
      {
        title: 'Chaos Mesh®',
        link: 'https://chaos-mesh.org',
      },
      {
        title: 'Slack',
        link: 'https://slack.tidb.io/invite?team=tidb-community&channel=everyone',
      },
      {
        title: '论坛',
        link: 'https://pingkai.cn/tidbcommunity/forum',
      },
      {
        title: '邮件列表',
        link: 'https://lists.tidb.io/g/main/subgroups',
      },
    ],
  },
  {
    title: '资源',
    items: [
      {
        title: '开始试用',
        link: 'https://docs.pingcap.com/zh/tidb/stable/quick-start-with-tidb',
      },
      {
        title: '最佳实践',
        link: 'https://docs.pingcap.com/zh/tidb/stable/tidb-best-practices',
      },
      {
        title: 'FAQ',
        link: 'https://docs.pingcap.com/zh/tidb/stable/tidb-faq',
      },
      {
        title: 'Release Notes',
        link: 'https://docs.pingcap.com/zh/tidb/dev/release-notes',
      },
      {
        title: '博客',
        link: 'https://pingkai.cn/tidbcommunity/forum/c/blog/l/latest',
      },
      {
        title: 'Github',
        link: 'https://github.com/pingcap/tidb',
      },
    ],
  },
  {
    title: '学习',
    items: [
      {
        title: '文档',
        link: 'https://docs.pingcap.com/zh',
      },
      {
        title: '案例学习',
        link: 'https://www.pingcap.cn/case',
      },
      {
        title: '平凯星辰 Education',
        link: 'https://learn.pingcap.cn',
      },
      {
        title: 'TiDB in Action',
        link: 'https://book.tidb.io',
      },
    ],
  },
];
